import { Box, FormControlLabelProps, FormGroup, RadioProps } from '@mui/material'
import React from 'react'
import CheckBox from '../../rhf-mui/ui/CheckBox'
import { useAppContext } from '../AppContext'
import { Toast } from '../Toast'
import DialogBase, { DialogBaseProps } from './DialogBase'
import { DialogOptions } from './DialogOptions'

export type MultiChoiceDialogBaseProps = DialogBaseProps & {
  options?: DialogOptions;
  dflt_values?: boolean[] | null;

  displayMember?: string;
  valueMember?: string;

  markProps?: RadioProps;// RadioProps - 統一的 Radio 屬性樣式
  formControlLabelProps?: FormControlLabelProps
}

const MultiChoiceDialogBase = ({
  options,
  dflt_values,

  displayMember = "label", valueMember = "value",

  markProps, formControlLabelProps,

  ...props }: MultiChoiceDialogBaseProps) => {

  const ctx = useAppContext();

  if (dflt_values == null) {
    dflt_values = new Array(options?.length).fill(false);
  }

  const [values, setValues] = React.useState<boolean[]>(dflt_values);

  return (
    <DialogBase
      dialogContentProps={{ dividers: true }}

      content={
        <Box sx={{ maxHeight: '400px' }}>

          <FormGroup >

            {options == null ? <></> : options.map((option: any, index: number) => {

              if (typeof (option) === "string") {
                option = { value: option, label: option }
              }
              const lbl = option[displayMember as string];

              return (
                <CheckBox key={"" + index}
                  label={lbl}

                  markProps={
                    {
                      // value: values[index],
                      checked: values[index],
                      onChange(event, checked) {
                        Toast.Show(ctx, "" + index);
                        values[index] = checked;
                        setValues([...values]);
                      },
                    }
                  }

                />
              )
            })}
          </FormGroup >

        </Box>
      }

      {...props}

      onDialogResult={(e) => {// 注意! 要放在 ...props 後面覆寫事件
        e.Data = values;
        props.onDialogResult?.(e);
      }}

    />
  )
}

export default MultiChoiceDialogBase